export const filterLeads = (leads, { search, status, channel, minScore, assignedTo }) => {
  return leads.filter((lead) => {
    // Search query
    if (search) {
      const q = search.toLowerCase();
      const matchName = lead.name?.toLowerCase().includes(q);
      const matchCompany = lead.company?.toLowerCase().includes(q);
      const matchId = lead.id?.toLowerCase().includes(q);
      const matchEmail = lead.email?.toLowerCase().includes(q);
      const matchPhone = lead.phone?.toLowerCase().includes(q);
      if (!matchName && !matchCompany && !matchId && !matchEmail && !matchPhone) {
        return false;
      }
    }

    // Status filter
    if (status && status !== "all" && lead.status?.toLowerCase() !== status.toLowerCase()) {
      return false;
    }

    // Channel filter
    if (channel && channel !== "all" && lead.channel?.toLowerCase() !== channel.toLowerCase()) {
      return false;
    }

    // Minimum Score filter
    if (minScore && lead.score < Number(minScore)) {
      return false;
    }

    // Assigned To filter
    if (assignedTo && assignedTo !== "all" && lead.assignedTo !== assignedTo) {
      return false;
    }

    return true;
  });
};

export const exportLeadsToCSV = (leads, filename = "tbs_crm_leads.csv") => {
  if (!leads || leads.length === 0) return false;

  const headers = [
    "ID", "Name", "Company", "Email", "Phone", "LINE", "Channel", 
    "Status", "Score", "Business Type", "Property Type", "Space", 
    "Timeline", "Budget", "Assigned To", "Created At"
  ];

  const rows = leads.map(l => [
    l.id || "",
    `"${(l.name || "").replace(/"/g, '""')}"`,
    `"${(l.company || "").replace(/"/g, '""')}"`,
    l.email || "",
    l.phone || "",
    l.lineId || "",
    l.channel || "",
    l.status || "",
    l.score || "",
    `"${(l.businessType || "").replace(/"/g, '""')}"`,
    `"${(l.propertyType || "").replace(/"/g, '""')}"`,
    `"${(l.space || "").replace(/"/g, '""')}"`,
    `"${(l.timeline || "").replace(/"/g, '""')}"`,
    `"${(l.budget || "").replace(/"/g, '""')}"`,
    `"${(l.assignedTo || "").replace(/"/g, '""')}"`,
    l.createdAt || ""
  ]);

  const csvContent = "\uFEFF" + [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return true;
};
